export default __webpack_public_path__ + "static/media/eye.1381a2ef.svg";